import React from 'react';
const OfficeIcon = (props: React.SVGProps<SVGSVGElement>) => (

    <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M22,11H19V2a1,1,0,0,0-1-1H6A1,1,0,0,0,5,2V7H2A1,1,0,0,0,1,8V22a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V12A1,1,0,0,0,22,11Zm-9,1v9H3V9H13Zm1-5H7V3H17v8H15V8A1,1,0,0,0,14,7Zm7,14H19V19a1,1,0,0,0-2,0v2H15V13h6ZM4,10H6v2H4Zm4,0h4v2H8ZM4,14H6v2H4Zm4,0h4v2H8ZM4,18H6v2H4Zm4,0h4v2H8Z" />

    </svg>

);

export default OfficeIcon;